import React from 'react';

// MUI
import ExpansionPanel from '@mui/material/Accordion'; // Note this is updated to Accordion in current MUI
import ExpansionPanelDetails from '@mui/material/AccordionDetails';
import ExpansionPanelSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import Box from '@mui/material/Box';
import List from './List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

// icons
import BusinessIcon from '@mui/icons-material/Business';
import { styled } from '@mui/material/styles';

const MyExpansionPanel = styled(ExpansionPanel)(({ theme }) => ({
  '&.Mui-expanded': {
    background: theme.palette.background.default,
    margin: '4px 0 !important',
    borderTop: `1px solid ${theme.palette.divider}`,
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: `inset 0px 10px 7px -10px ${theme.palette.divider}, inset 0px -10px 7px -10px ${theme.palette.divider}`,
    '& .MuiAccordionSummary-content': {
      margin: '4px 0 0',
    },
  },
}));

const MyExpansionPanelDetails = styled(ExpansionPanelDetails)({
  padding: '0 0 10px 10px',
});

export const NavExpansionPanel = ({
  onClick,
  expanded,
  selected,
  Icon = <BusinessIcon />,
  title = 'Title',
  subtitle,
  children,
  SummaryChildren,
}) => {
  return (
    <MyExpansionPanel expanded={expanded}>
      <List>
        <Box display="flex" alignItems="center">
          <ListItem button onClick={onClick} selected={selected}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Box display="flex" alignItems="center">
                {Icon && <ListItemIcon>{Icon}</ListItemIcon>}
                <ListItemText primary={title} secondary={subtitle} />
              </Box>
            </ExpansionPanelSummary>
          </ListItem>
          {SummaryChildren}
        </Box>
      </List>
      <MyExpansionPanelDetails>{children}</MyExpansionPanelDetails>
    </MyExpansionPanel>
  );
};

export default NavExpansionPanel;
